const BASE_URL = process.env.REACT_APP_BASE_URL;

export const login = async (credentials) => {
  const res = await fetch(`${BASE_URL}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(credentials),
  });

  if (!res.ok) throw new Error('Invalid credentials');

  return await res.json(); // Expected: { user, token }
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};
